// Single place for product naming used across the marketing site and the app.
export const BRAND = {
    name: "Reputation AI",
    tagline: "AI Marketing Manager",
    company: "Raybotix Digital",
    city: "Ahmedabad, India",
    // Contact address shown on the public site and legal pages. Set
    // REACT_APP_CONTACT_EMAIL at build time to override.
    email: process.env.REACT_APP_CONTACT_EMAIL || "hello@raybotixdigital.online",
};

export default BRAND;
